const getEnvironment = () => {
  // Build zamanında belirlenmiş environment değişkenini kullan
  // REACT_APP_ prefix'i ile başlayan değişkenler build'e dahil edilir
  const buildTimeEnv = process.env.REACT_APP_ENV;
  
  // Eğer build zamanında environment belirlenmediyse, 
  // runtime'da hostname'e bakarak belirle (backward compatibility için)
  if (!buildTimeEnv || buildTimeEnv === 'development') {
    const host = window?.location?.hostname;
    const testDomains = [
      'tstbireysel.istanbulkart.istanbul',
      'localhost',
      '192.168.1.40',
    ];

    return testDomains.includes(host);
  }
  
  // Build zamanında environment production ise false döndür (production environment)
  return buildTimeEnv !== 'production';
};

export default getEnvironment;
